import { useHandleRequestErrors } from 'utils/hooks';
import { ResponseError } from 'services/api/base';
import { useGetWBSequentialDVOptionsQuery } from 'services/api/Meteorology/Agro/WaterBalanceSequential/DetailedView';

export default function useOptions() {
  const { data, isLoading, error } = useGetWBSequentialDVOptionsQuery();

  useHandleRequestErrors(error as ResponseError);

  return { options: data, isLoading };
}
